import "./polyfills";

import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import alerts from "web/script/utils/alerts";
import routes from "web/script/routing/routes";
import loadFonts from "web/script/utils/load-fonts";
import jinjaToJs from "jinja-to-js";
import { installJinjaFilters } from "web/script/modules/jinja-filters";
import { installJinjaGlobals } from "web/script/modules/jinja-globals";
import "web/script/components/index";
import { initialiseReact } from "web/react/main";

loadFonts();
installJinjaFilters(jinjaToJs);
installJinjaGlobals(jinjaToJs);

analytics.init();
userProfiler.init();
browser.init();
alerts.init();
baustein.init();

if (baustein.getInstanceOf("lyst-app")) {
    routes.setup();
}

analytics.pageView();
initialiseReact();
// we expose this as a global so 3rd parties can interact with our analytics
window.lystAnalytics = {
    event: analytics.event.bind(analytics),
};
